// let op = "2+2*2/2+2*7";

const allSymbols = {
    "/": 1,
    "*": 1,
    "+": 1,
    "-": 1
}

const specialSymbols = {
    ">": 1,
    "<": 1,
    "<=":1,
    ">=":1,
    "=": 1,
    "!=": 1,
    "&":1,
    "|":1
}

/**
 * Check for curly bracket
 * Check for bracket
 */

const writePosition = (pos) => {
    console.log(pos, 'pos');
    const lastTxt = pos.toString().slice(-1);
    console.log(lastTxt, 'lastTxt');
    switch (lastTxt) {
        case '1':
            return 'st';
        case '2':
            return 'nd';
        case '3':
            return 'rd';
        default:
            return 'th';
    }
};

export const parseResult = (result, template, ) => {
    let mainRes = JSON.parse(result.result);
    // let groupRes = JSON.parse(results.result[resultSet].groups[resultGroup].result);

    // for (let x in groupRes) {
    //     let txSplit = x.split('_');
    //     let pos = txSplit[0].split(':');
    //     let posS = txSplit[1].split(':');
    //     let formula = template[`${posS[0]}`].content[`${posS[2]}`].extra;
    //     let func; let func2;

    //     //console.log(formula, 'formula')
    //     if (formula.split('[').length > 1) {
    //         func = formula.split('{')[0];
    //         func2 = formula.split('{')[1].split('[')[0];
    //     }
    //     else {
    //         func = formula.split('{')[0];
    //     }

    //     let gRes;
    //     //console.log(func, 'func')
    //     switch (func) {
    //         case 'GHIGHEST':
    //             if (func2 === 'CTOTAL') {
    //                 gRes = 0;
    //                 for (let y in groupRes[x]) {
    //                     let indTotal = 0; let zpt;
    //                     for (let z in groupRes[x][y]) {
    //                         zpt = z.split(':')[1];
    //                         indTotal += Number(groupRes[x][y][z]);
    //                     }

    //                     if (indTotal > gRes) {
    //                         gRes = indTotal;
    //                         mainRes[`${posS[0]}`][Number(zpt)][`${posS[2]}`] = indTotal;
    //                     }
    //                 }
    //             }
    //             else {
    //                 let indTotal = {};
    //                 for (let y in groupRes[x]) {
    //                     for (let z in groupRes[x][y]) {
    //                         const zpt = z.split(':');

    //                         if (indTotal[`${z}`]) {
    //                             if (Number(groupRes[x][y][z]) > indTotal[`${z}`]) {
    //                                 indTotal[`${z}`] = Number(groupRes[x][y][z]);
    //                                 mainRes[`${posS[0]}`][Number(zpt[1])][`${posS[2]}`] = Number(groupRes[x][y][z]);
    //                             }
    //                         }
    //                         else {
    //                             indTotal[`${z}`] = Number(groupRes[x][y][z]);
    //                             mainRes[`${posS[0]}`][Number(zpt[1])][`${posS[2]}`] = Number(groupRes[x][y][z]);
    //                         }
    //                     }
    //                 }
    //             }
    //             break;
    //         case 'GPOSITION':
    //             if (func2 === 'CTOTAL') {
    //                 let stuScore = {}; let myScore; let zpt;
    //                 for (let y in groupRes[x]) {
    //                     let indTotal = 0;
    //                     for (let z in groupRes[x][y]) {
    //                         zpt = z.split(':')[1];
    //                         indTotal += Number(groupRes[x][y][z]);
    //                     }
    //                     //indTotal *= -1;
    //                     if (!stuScore[`${indTotal}`])
    //                         stuScore[`${indTotal}`] = {};

    //                     if (Number(y) === usResult.id) {
    //                         myScore = indTotal;
    //                     }
    //                 }

    //                 let stuArry = [];
    //                 console.log(stuScore, 'stuScore');
    //                 for (let idy in stuScore) {
    //                     stuArry.push(idy);
    //                 }
    //                 console.log(stuArry, 'stuArray');
    //                 let spos = 1;
    //                 for (let i = stuArry.length; i > 0; i--) {
    //                     stuScore[`${stuArry[i - 1]}`].poss = spos;
    //                     spos++;
    //                 }

    //                 console.log(myScore, 'myscore');
    //                 if (myScore)
    //                     mainRes[`${posS[0]}`][0][`${posS[2]}`] = stuScore[`${myScore}`].poss + writePosition(stuScore[`${myScore}`].poss);
    //             }
    //             else {
    //                 let stuScore = {};

    //                 for (let y in groupRes[x]) {
    //                     for (let z in groupRes[x][y]) {
    //                         const zpt = z.split(':');

    //                         if (stuScore[`${zpt[1]}`]) {
    //                             if (stuScore[`${zpt[1]}`][`${groupRes[x][y][z]}`])
    //                                 stuScore[`${zpt[1]}`][`${groupRes[x][y][z]}`].studId.push(y);
    //                             else {
    //                                 stuScore[`${zpt[1]}`][`${groupRes[x][y][z]}`] = {};
    //                                 stuScore[`${zpt[1]}`][`${groupRes[x][y][z]}`].studId = [y];
    //                             }
    //                         }
    //                         else {
    //                             stuScore[`${zpt[1]}`] = {};
    //                             stuScore[`${zpt[1]}`][`${groupRes[x][y][z]}`] = {};
    //                             stuScore[`${zpt[1]}`][`${groupRes[x][y][z]}`].studId = [y];
    //                         }
    //                     }
    //                 }

    //                 for (let east in stuScore) {
    //                     let allScore = [];
    //                     for (let east1 in stuScore[east]) {
    //                         allScore.push(Number(east1));
    //                     }
    //                     let cnt = 1;
    //                     for (let i = allScore.length; i > 0; i--) {
    //                         stuScore[east][allScore[i - 1]].pos = cnt;
    //                         cnt++;
    //                     }

    //                     /*let preXC = Number.NEGATIVE_INFINITY; let stuPos = 0;
    //                     for(let idy in allScore){
    //                         if(Number(idy) != preXC){
    //                             stuPos++;
    //                             preXC = Number(idy);
    //                             allScore[idy] = stuPos;
    //                         }
    //                     }*/
    //                     let mv = stuScore[east][`${mainRes[pos[0]][Number(east)][pos[2]]}`].pos;
    //                     mainRes[`${posS[0]}`][Number(east)][`${posS[2]}`] = mv + writePosition(mv);//allScore[`${mSVal}`];
    //                 }
    //             }
    //             break;
    //         case 'GLOWEST':
    //             if (func2 === 'CTOTAL') {
    //                 gRes = 0;
    //                 for (let y in groupRes[x]) {
    //                     let indTotal = 0; let zpt;
    //                     for (let z in groupRes[x][y]) {
    //                         zpt = z.split(':')[1];
    //                         indTotal += Number(groupRes[x][y][z]);
    //                     }

    //                     if (indTotal < gRes) {
    //                         gRes = indTotal;
    //                         mainRes[`${posS[0]}`][Number(zpt)][`${posS[2]}`] = indTotal;
    //                     }
    //                 }
    //             }
    //             else {
    //                 let indTotal = {};
    //                 for (let y in groupRes[x]) {
    //                     for (let z in groupRes[x][y]) {
    //                         const zpt = z.split(':');

    //                         if (indTotal[`${z}`]) {
    //                             if (Number(groupRes[x][y][z]) < indTotal[`${z}`]) {
    //                                 indTotal[`${z}`] = Number(groupRes[x][y][z]);
    //                                 mainRes[`${posS[0]}`][Number(zpt[1])][`${posS[2]}`] = Number(groupRes[x][y][z]);
    //                             }
    //                         }
    //                         else {
    //                             indTotal[`${z}`] = Number(groupRes[x][y][z]);
    //                             mainRes[`${posS[0]}`][Number(zpt[1])][`${posS[2]}`] = Number(groupRes[x][y][z]);
    //                         }
    //                     }
    //                 }
    //             }
    //             break;
    //         case 'GAVERAGE':
    //             if (func2 === 'CTOTAL') {
    //                 gRes = 0; let cnt = 0;
    //                 for (let y in groupRes[x]) {
    //                     cnt++;
    //                     let indTotal = 0; let zpt;
    //                     for (let z in groupRes[x][y]) {
    //                         zpt = z.split(':')[1];
    //                         indTotal += Number(groupRes[x][y][z]);
    //                     }

    //                     gRes += indTotal;
    //                     /*if(indTotal > gRes){
    //                         gRes = indTotal
    //                         mainRes[`${posS[0]}`][Number(zpt)][`${posS[2]}`] = indTotal;
    //                     }*/
    //                     mainRes[`${posS[0]}`][Number(zpt)][`${posS[2]}`] = gRes / cnt;
    //                 }

    //             }
    //             else {
    //                 let indTotal = {}; let indCnt = {};
    //                 for (let y in groupRes[x]) {
    //                     for (let z in groupRes[x][y]) {
    //                         const zpt = z.split(':');

    //                         if (indTotal[`${z}`]) {
    //                             indCnt[`${z}`] = indCnt[`${z}`] + 1;
    //                             indTotal[`${z}`] = Number(indTotal[`${z}`]) + Number(groupRes[x][y][z]);

    //                             mainRes[`${posS[0]}`][Number(zpt[1])][`${posS[2]}`] = indTotal[`${z}`] / indCnt[`${z}`];
    //                             /*if(Number(groupRes[x][y][z]) > indTotal[`${z}`]){
    //                                 indTotal[`${z}`] = Number(groupRes[x][y][z]);
    //                                 mainRes[`${posS[0]}`][Number(zpt[1])][`${posS[2]}`] = Number(groupRes[x][y][z]);
    //                             }*/
    //                         }
    //                         else {
    //                             indCnt[`${z}`] = 1;
    //                             indTotal[`${z}`] = Number(groupRes[x][y][z]);
    //                             mainRes[`${posS[0]}`][Number(zpt[1])][`${posS[2]}`] = Number(groupRes[x][y][z]);
    //                         }
    //                     }
    //                 }
    //             }
    //             break;
    //         default: break;
    //     }
    // }

    // console.log(mainRes, template, 'result')

    // for (let x in mainRes) {
    //     const len = mainRes[x].length;

    //     for (let i = 0; i < len; i++) {
    //         let colLen = Object.keys(template[x].content).length;
    //         for (let j = 0; j < colLen; j++) {
    //             const colType = template[x].content[`${j}`].type;
    //             if (colType === 'comtxt') {
    //                 if (!mainRes[x][i][`${j}`]) {
    //                     mainRes[x][i][j] = checkCurlyBracket(template[x].content[`${j}`].extra, {
    //                         section: x, row: i, column: j
    //                     }, mainRes);
    //                 }
    //             }
    //             else if (colType === 'infdtxt') {
    //                 if (!mainRes[x][i][`${j}`]) {
    //                     let conditions = JSON.parse(template[x].content[`${j}`].extra);
    //                     let values = JSON.parse(template[x].content[`${j}`].extraValue);

    //                     const conLen = conditions.length;
    //                     for (let k = 0; k < conLen; k++) {
    //                         let isTrue = Number(checkCurlyBracket(conditions[k], {
    //                             section: x, row: i, column: j
    //                         }, mainRes, true)) === 1 ? true : false;

    //                         if (isTrue) {
    //                             mainRes[x][i][`${j}`] = values[k];
    //                             break;
    //                         }
    //                     }
    //                 }
    //             }
    //         }
    //     }
    // }
    return mainRes;
};

const performOperation = (num1, num2, op)=>{
    let result = 0;
    switch(op){
        case "/":
            result = num1 / num2;
            break;
        case "*":
            result = num1 * num2;
            break;
        case "+":
            result = num1 + num2;
            break;
        case "-":
            result = num1 - num2;
            break;
        default: break;
    }
    return result.toString();
}

const performLogicOperation = (num1, num2, op)=>{
    let result = 0;
    switch(op){
        case ">":
            result = num1 > num2 ? 1 : 0
            break;
        case ">=":
            result = num1 >= num2 ? 1 : 0;
            break;
        case "<":
            result = num1 < num2 ? 1 : 0;
            break;
        case "<=":
            result = num1 <= num2 ? 1 : 0;
            break;
        case "=":
            result = num1 === num2 ? 1 : 0;
            break;
        case "!=":
            result = num1 !== num2 ? 1: 0;
            break;
        case "&":
            result = num1 && num2;
            break;
        case "|":
            result = num1 || num2;
            break;
        default: break;
    }
    // console.log(result,'gee');
    return result.toString();
}

const checkSymbol = (symbol,pos, text)=>{
    let start = 0; let end = text.length;

    let i = 1;

    while((pos - i) > start){
        if(allSymbols[`${text[pos - i]}`]) start = pos -i +1; 
        i++;
    }
    let firstNumber = Number(text.slice(start, pos));
    i = 1;
    while((pos + i) < end){
        if(allSymbols[`${text[pos + i]}`]) end = pos + i;
        i++;
    }
    let secondNumber = Number(text.slice(pos + 1, end));
    text = text.slice(0, start) + performOperation(firstNumber, secondNumber, symbol) + text.slice(end, text.length);
    return text;
}

const checkForDoubleSymbol = (symbol,pos,pos2, text)=>{
    let start = 0; let end = text.length;

    let i = 1;

    while((pos - i) > start){
        if(specialSymbols[`${text[pos - i]}`]) start = pos -i +1; 
        i++;
    }
    let firstNumber = Number(text.slice(start, pos));
    i = 1;
    while((pos2 + i) < end){
        if(specialSymbols[`${text[pos2 + i]}`]) end = pos2 + i;
        i++;
    }
    let secondNumber = Number(text.slice(pos2 + 1, end));
    //console.log(symbol,"start")
    text = text.slice(0, start) + performLogicOperation(firstNumber, secondNumber, symbol) + text.slice(end, text.length);
    //console.log(text, 'tx')
    return text;
}

const insertOperation = (text)=>{
    const sym = Object.keys(allSymbols);
    for(let i = 0; i < sym.length; i++){
        let isFound = true;
        while(isFound){
            isFound = false;
            for(let j = 0; j < text.length; j++){
                if(text[j] === sym[i]){
                    text = checkSymbol(sym[i], j, text);
                    console.log(text,`${j} ${i}`);
                    isFound = true;
                }
            }
        }
        
    }
    return text;
}

export const insertOperationForDoubleSymbol = (text)=>{
    let isFound = true;
    while(isFound){
        isFound = false;
        for(let j = 0; j < text.length; j++){
            if(specialSymbols[`${text[j]}`] && specialSymbols[`${text[j+1]}`]){
                text = checkForDoubleSymbol(text[j] + text[j+1], j, j+1, text);
                isFound = true;
            }
            else if(specialSymbols[`${text[j]}`]){
                text = checkForDoubleSymbol(text[j], j, j, text);
                isFound = true;
            }
        }
    }
    return text;
}

const checkBracket = (text, isCondition)=>{
    let stack = []; let start = 0;
    do{
        stack = [];
        for(let i = 0; i < text.length; i++){
            if(text[i] === '(')stack.push(i);
            if(text[i] === ')'){
                start = stack.pop();
                let nTxt = isCondition ? insertOperationForDoubleSymbol(text.slice(start + 1, i)) : insertOperation(text.slice(start + 1, i));
                text = text.slice(0, start) + nTxt + text.slice(i+1, text.length);
            }
        }
        //stack = []
    }
    while(stack.length > 0)
    return isCondition? insertOperationForDoubleSymbol(text) : insertOperation(text);
}
export const filterTextUsingSpace = (text)=>{
    return text.split(' ').join('')
}
export const filterTextUsingSymbol = (text, isCondition)=>{
    const newText = [];
    for(let i = 0; i < text.length; i++){
        switch(text[i]){
            case '(':
                if(!allSymbols[`${text[i-1]}`])
                    newText.push('*');
                newText.push(text[i]);
                break;
            case '-':
                if(text[i - 1] === '-'){
                    newText.pop();
                    newText.push('+');
                }
                else if(text[i - 1] === '+'){
                    newText.pop();
                    newText.push('-');
                }              
                else newText.push(text[i])
                break;
                case '+':
                    if(text[i - 1] === '-'){
                        newText.pop();
                        newText.push('-');
                    }
                    else if(text[i - 1] === '+'){
                        newText.pop();
                        newText.push('+');
                    }
                    else newText.push(text[i]);
                break;
            default:
                newText.push(text[i])
        }
    }
    return checkBracket(newText.join(''), isCondition);
}

 /*
  {0:0:1}
*/
const checkStructure = (structure, posObject, result) => {
    
    let eachStruct = structure.split(':');
    let section = eachStruct[0] === 'S' ? Number(posObject.section) : Number(eachStruct[0])-1;
    let row = eachStruct[1] === 'R' ? posObject.row : Number(eachStruct[1])-1;
    let column = eachStruct[2] === 'C' ? posObject.column : Number(eachStruct[2])-1;
    console.log(structure, posObject, result, 'str')
    console.log(section)
    return Number(result[section][row][`${column}`])
}
//{S:R:0}*{S:R:1}
export const checkCurlyBracket = (text, posObject, result, isCondition=false)=>{
    text = filterTextUsingSpace(text);
    let stack = []; let start = 0;
        for(let i = 0; i < text.length; i++){
            if(text[i] === '{')stack.push(i);
            if(text[i] === '}'){
                start = stack.pop();
                text = text.slice(0, start) + checkStructure(text.slice(start + 1, i), posObject, result) + text.slice(i+1, text.length);
                i=0;
                //console.log(text,'formula')
            }
        }
    return filterTextUsingSymbol(text, isCondition);
}


/*const result = {
    '0':[{}],
    '1':[{}],
    '2':[{
        '0': 'Phy111',
        '1': '10',
        '2': '5',
        '3': '15',
        '5': '50'
    }]
}

console.log(checkCurlyBracket('{S:R:4}>10',{
    section: '2', row: 0, column: 5
}, result, true));*/